import React from "react";
import ToggleButton from "../ToggleButton";
import SaleToggle from "./SaleToggle";

function Control({ label, children }) {
  return (
    <span className="pc-control">
      <span className="pc-control__label">{label}</span>
      {children}
    </span>
  );
}

export default function ProductControls({ item, index, toggle, toggleSale, toggleTempUnavailable }) {
  return (
    <div className="pc-controls" data-testid="product-controls">
      <Control label="out of stock">
        <ToggleButton
          ariaLabel="out of stock"
          checked={!!item.is_out_of_stock}
          onToggle={(e) => toggle(e, item.id, index)}
        />
      </Control>
      {toggleSale && (
        <Control label="sale">
          <SaleToggle item={item} onChange={(on, pct) => toggleSale(item.id, index, on, pct)} />
        </Control>
      )}
      {toggleTempUnavailable && (
        <Control label="off for today">
          <ToggleButton
            ariaLabel="off for today"
            checked={!!item.is_temporarily_unavailable}
            onToggle={(e) => toggleTempUnavailable(e, item.id, index)}
          />
        </Control>
      )}
    </div>
  );
}
